<div class="wrapper-body" *ngIf="apptDetails">
    <div class="page-header align-items-lg-center d-flex flex-column flex-md-row">
        <h3 class="mb-4 mb-md-0">{{apptDetails.parentDetails.studentFirstName}}
            {{apptDetails.parentDetails.studentLastName}} Re-assign Appointment</h3>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="card">
                <h5 class="mb-0 text-purple">Appointment Detail</h5>
                <hr>
                <div class="row">
                    <div class="col-md-6">
                        <label class="text-grey">Location</label>
                        <p> {{apptDetails.appointmentDetails.location}}</p>
                    </div>
                    <div class="col-md-6">
                        <label class="text-grey">Diagnostician</label>
                        <p> {{apptDetails.appointmentDetails.diagnosticianName}}</p>
                    </div>
                    <div class="col-md-6">
                        <label class="text-grey"> Date</label>
                        <p> {{apptDetails.appointmentDetails.schedules[0].appointmentDate}}</p>
                    </div>
                    <div class="col-md-6">
                        <label class="text-grey">Time</label>
                        <p> {{apptDetails.appointmentDetails.schedules[0].appointmentTime}}</p>
                    </div>
                    <div class="col-md-6">
                        <label class="text-grey">Assessment Type</label>
                        <p> {{apptDetails.appointmentDetails.assesmentType}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <form class="custom-form" [formGroup]="AppointmentForm" autocomplete="off">
                <div class="card light">
                    <h5 class="mb-0 text-purple">Re-assign Details</h5>
                    <hr>
                    <div class="row">
                        <div class="col-12" *ngIf="locations">
                            <select (change)="selectLocation()" formControlName="locationId" [(ngModel)]="locationId"
                                id="testingLocation">
                                <option value="" selected disabled>Choose Testing Location</option>
                                <option *ngFor="let city of locations.data" [ngValue]="city.id">{{city.name}}
                                </option>
                            </select>
                            <div *ngIf="diagAvailable" class="text-danger">
                                No Diagnostician for this location
                              </div>
                        </div>
                        <div class="col-12" >
                            <select (change)="selectDiag()" formControlName="diagnosticianId" [(ngModel)]="diagId"
                                id="diag">
                                <option value="" selected disabled>Choose Diagnostician</option>
                                <option *ngFor="let city of diagList" [ngValue]="city.id">{{city.firstName}}
                                    {{city.lastName}}</option>
                            </select>
                        </div>
                        <div class="col-12 my-2">
                            <button [ngClass]="{'grey' : AppointmentForm.invalid }" [disabled]="AppointmentForm.invalid"
                                type="submit" (click)="submitForm()" class="theme-button green">Re-assign</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>



<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple"></ngx-spinner>